import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { updated } from './updatedAction';

export const outputActions = [updated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
